import React from 'react';

const SvgAquarius = (props) => {
  return (
    <svg
      viewBox="0 0 46.88 26.03"
      width="1em"
      height="1em"
      {...props}
    >
      <style>{`.aquarius_svg__st0{fill-rule:evenodd;clip-rule:evenodd}`}</style>
      <path
        className="aquarius_svg__st0"
        d="M37 11.12c-4.09 0-5.51-3-6.55-5.2C29.44 3.8 28.94 3 27.62 3c-1.81 0-2.8 1.62-4.1 4.1-1.05 1.98-2.13 4.03-4.27 4.03-4.09 0-5.51-3-6.55-5.2C11.69 3.8 11.19 3 9.88 3c-1.81 0-2.8 1.62-4.1 4.1-1.05 1.98-2.13 4.03-4.27 4.03-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5C1.9 8.02 2.7 6.51 3.13 5.7 4.39 3.29 6.13 0 9.88 0c3.34 0 4.56 2.57 5.54 4.64 1.05 2.22 1.75 3.48 3.84 3.48.39-.11 1.19-1.62 1.62-2.43 1.26-2.4 3-5.69 6.74-5.69 3.33 0 4.56 2.57 5.54 4.64 1.06 2.22 1.75 3.48 3.84 3.48.39-.11 1.19-1.62 1.62-2.43C39.89 3.29 41.63 0 45.38 0c.83 0 1.5.67 1.5 1.5S46.2 3 45.38 3c-1.81 0-2.8 1.62-4.1 4.1-1.05 1.98-2.14 4.02-4.28 4.02M37 26.03c-4.09 0-5.51-3-6.55-5.2-1.01-2.12-1.51-2.93-2.82-2.93-1.81 0-2.8 1.62-4.1 4.1-1.05 1.98-2.13 4.03-4.27 4.03-4.09 0-5.51-3-6.55-5.2-1.01-2.12-1.51-2.93-2.82-2.93-1.81 0-2.8 1.62-4.1 4.1-1.05 1.98-2.13 4.03-4.27 4.03-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5c.39-.11 1.19-1.62 1.62-2.43 1.27-2.4 3.01-5.69 6.76-5.69 3.34 0 4.56 2.57 5.54 4.64 1.05 2.22 1.75 3.48 3.84 3.48.39-.11 1.19-1.62 1.62-2.43 1.27-2.4 3.01-5.69 6.76-5.69 3.33 0 4.56 2.57 5.54 4.64 1.06 2.22 1.75 3.48 3.84 3.48.39-.11 1.19-1.62 1.62-2.43 1.27-2.4 3.01-5.69 6.76-5.69.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-1.81 0-2.8 1.62-4.1 4.1-1.09 1.97-2.18 4.02-4.32 4.02"
      />
    </svg>
  );
};

export default SvgAquarius;
